import { cn } from '@/lib/cn';

/**
 * CogniTest brand lockup — an original friendly "smiling squircle" mark
 * (our own mascot, TestGorilla-inspired style, not their asset) + wordmark.
 */
export function Logo({ variant = 'full', className, invert }: { variant?: 'full' | 'mark'; className?: string; invert?: boolean }) {
  const Mark = (
    <span className="relative inline-flex items-center justify-center w-8 h-8 rounded-[10px] bg-primary-500 text-white flex-shrink-0">
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" aria-hidden="true">
        <circle cx="8.5" cy="10" r="1.5" fill="currentColor" />
        <circle cx="15.5" cy="10" r="1.5" fill="currentColor" />
        <path d="M7.3 14c1.3 1.7 3 2.6 4.7 2.6s3.4-.9 4.7-2.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      </svg>
    </span>
  );

  if (variant === 'mark') return <span className={className}>{Mark}</span>;

  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      {Mark}
      <span className={cn('font-display text-xl font-bold tracking-tight', invert ? 'text-white' : 'text-ink-900')}>
        Cogni<span className="text-primary-500">Test</span>
      </span>
    </span>
  );
}
